import { ref } from 'vue';
import { loadingController } from '@ionic/vue';

export function useLoadingController() {
  const loading = ref<HTMLIonLoadingElement | null>(null);

  const presentLoading = async (message: string) => {
    loading.value = await loadingController.create({
      message: message,
    });
    return loading.value.present();
  };

  const dismissLoading = async () => {
    if (loading.value) {
      await loading.value.dismiss();
      loading.value = null;
    }
  };

  return {
    presentLoading,
    dismissLoading,
  };
}
